class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    if (parsedState.sections) {
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector).replace(/\(Preorder\)/g, '');
      }));
    } else {
      // update cart-notification-product
      const productImage = document.querySelector('.product__media-item .product__media img')
      const cartProducts = document.getElementById('cart-notification-product')
      let cartProductDetails = ''
      let cartProductQuantities = 0
      for (const item of parsedState.items) {
        cartProductQuantities += parseInt(item.quantity)
        let propertyDetails = ''
        for (const propertyName in item.properties) {
          if (propertyName !== '_intuitive_cid' && propertyName !== '_iq') {
            const propertyValue = item.properties[propertyName];
            propertyDetails += `
              <div class="product-option">
                <dt>${propertyName}: </dt>
                <dd>${propertyValue}</dd>
              </div>
            `
          }
        }
        cartProductDetails += `
          <div style="margin-bottom: 30px;">
            <p class="caption-with-letter-spacing light">
              <span>SKU:</span>${item.sku}
            </p><h3 class="cart-notification-product__name h4">${item.title.split(' - ')[0]}</h3>
            <dl>
              <div class="product-option">
                <dt>Option:</dt>
                <dd>${item.title.split(' - ')[1]}</dd>
              </div>
              ${propertyDetails}
            </dl>
          </div>
        `
      }
      cartProducts.innerHTML = `
        <div class="cart-notification-product__image global-media-settings">
          <img src="${productImage.src}" alt="Abigail Sofa" width="70" height="56" loading="lazy">
        </div>
        <div>
          ${cartProductDetails.replace(/\(Preorder\)/g, '')}
        </div>
      `

      // update cart-icon-bubble
      const cartIconBubble = document.getElementById('cart-icon-bubble')
      const beforeAddToCartNumber = cartIconBubble.querySelector('[aria-hidden=true]') ? parseInt(cartIconBubble.querySelector('[aria-hidden=true]').innerText) : 0
      const addToCartNumber = document.querySelector('.quantity__input')? parseInt(document.querySelector('.quantity__input').value) : 0
      const afterAddToCartNumber = beforeAddToCartNumber + addToCartNumber
      if (cartIconBubble.querySelector('[aria-hidden=true]')) {
        cartIconBubble.querySelector('[aria-hidden=true]').innerText = `${afterAddToCartNumber}`
      } else {
        const spanElement = document.createElement('span');
        spanElement.setAttribute('aria-hidden', 'true');
        spanElement.innerHTML = `${afterAddToCartNumber}`;
        cartIconBubble.appendChild(spanElement);
      }
      if (cartIconBubble.querySelector('.visually-hidden')) {
        cartIconBubble.querySelector('.visually-hidden').innerText = `${afterAddToCartNumber} item${afterAddToCartNumber > 1 ? 's' : ''}`
      } else {
        const spanElement = document.createElement('span');
        spanElement.classList.add('visually-hidden');
        const textContent = `${afterAddToCartNumber} item${afterAddToCartNumber > 1 ? 's' : ''}`;
        spanElement.textContent = textContent;
        cartIconBubble.appendChild(spanElement);
      }

      // update cart-notification-button
      const cartNotificationButton = document.getElementById('cart-notification-button')
      cartNotificationButton.innerText = `View my cart (${afterAddToCartNumber})`
    }

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble',
        selector: '.cart-count-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
